export default [
  {
    path: 'mantenedores/documentos',
    name: 'maintainer-files',
    meta: { permiso: 'ED005', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/MantenedorDocumentos')
  },
  {
    path: 'mantenedores/instituciones',
    name: 'maintainer-institutions',
    meta: { permiso: 'ED006', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/MantenedorInstitutions')
  },
  {
    path: 'mantenedores/destinos',
    name: 'maintainer-subjects',
    meta: { permiso: 'ED007', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/MantenedorDestinos')
  },
  {
    path: 'mantenedores/servicios',
    name: 'maintainer-services',
    meta: { permiso: 'ED110', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/MantenedorServicios')
  },
  {
    path: 'mantenedores/regiones',
    name: 'maintainer-regions',
    meta: { permiso: 'ED111', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/MantenedorRegiones')
  },
  {
    path: 'mantenedores/actividades',
    name: 'maintainer-activities',
    meta: { permiso: 'ED048', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/Activities')
  },
  {
    path: 'mantenedores/estados-kanban',
    name: 'maintainer-kanban-states',
    meta: { permiso: 'ED059', requiereLogin: true },
    component: () => import('@/febos/chile/tools/vistas/States')
  },
  {
    path: 'empresa/perfiles',
    name: 'access-profiles',
    meta: { permiso: 'ED124', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/management/vistas/AccessProfiles')
  },
  {
    path: 'empresa/integraciones',
    name: 'integrations-manager',
    meta: { permiso: 'WB510', requiereLogin: true },
    component: () => import('@/febos/global/management/vistas/IntegrationsManager')
  },
  {
    path: 'mantenedores/tipos-adjuntos',
    name: 'maintainer-attachment-types',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/chile/tools/vistas/MaintainerAttachmentTypes')
  },
];
